<template>
  <div class="header-container">
    <el-row>
      <el-col :span="24">
        <div class="header">
          <div class="header-body">
            <router-link to="/index">
              <div class="logo">
                <img src="@/assets/header-logo.svg" />
              </div>
            </router-link>
            <div class="menu">
              <div class="search">
                <el-input
                  v-model="keyWord"
                  placeholder="搜索课程或关键词"
                  @keyup.enter.native="toSearch"
                >
                  <i
                    style="cursor: pointer"
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="toSearch"
                  ></i>
                </el-input>
              </div>
              <div class="login">
                <div
                  class="wx-login"
                  @click.stop="showBarcode"
                  v-if="!isLogin"
                >
                  登录
                </div>
                <div
                  class="user-center"
                  v-else
                  @mouseleave="mineShow = false"
                >
                  <div class="user-name" @mouseenter="mineShow = true">
                    <img class="avatar-img" :src="avatarUrl" alt="" />
                    <span>{{ userName}}</span>
                  </div>
                  <div v-show="mineShow" class="user-card">
                    <div class="mine item" @mouseenter="mineHover = true" @mouseleave="mineHover=false">
                      <img v-if="mineHover" src="@/assets/mine-hover.svg" alt="">
                      <img v-else src="@/assets/mine.svg" alt="">
                      <div tag="span" @click="toMine">
                        <div>个人中心</div>
                      </div>
                    </div>
                    <div class="logout item"  @mouseenter="logoutHover = true" @mouseleave="logoutHover=false">
                      <img v-show="!logoutHover" src="@/assets/logout.svg" alt="" />
                      <img v-show="logoutHover" src="@/assets/logout-hover.svg" alt="" />
                      <span @click="logout">退出登录</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { removeToken, getToken, getId } from '@/utils/auth'
import UserCenterCard from './UserCenterCard'
import { getLatestWatched } from '@/api/header'
import { logout } from '@/utils/logout'
export default {
  name: 'Header',
  components: {
    userCard: UserCenterCard
  },
  data () {
    return {
      isActive: {
        test1: true,
        test2: false,
        test3: false
      },
      latestWatchedList: '',
      keyWord: '',
      mineShow: false,
      mineHover: false,
      logoutHover: false
    }
  },
  computed: {
    avatarUrl () {
      return this.$store.getters.getavatarUrl
    },
    isLogin () {
      return this.$store.getters.getLogin
    },
    userName () {
      return this.$store.getters.getUserName
    },
    needWechatLogin () {
      return this.$store.state.needWechatLogin
    }
  },
  created () {
    this.judgeSelectedMenu()
  },
  watch: {
    $route () {
      this.judgeSelectedMenu()
    },
    needWechatLogin () {
      if (this.needWechatLogin) {
        this.$store.commit('SET_WECHAT_LOGIN', false)
      }
    }
  },
  methods: {
    toMine () {
      if (!getToken()) {
        if (getId()) {
          this.$message.error('登录过期，请先进行登录')
        } else {
          this.$message.error('请先进行登录')
        }
        logout(true)
      } else {
        this.$router.push('/mine')
      }
    },
    toSearch () {
      this.$router.push({path: '/search', query: {keyword: this.keyWord}})
    },
    judgeSelectedMenu () {
      let route = this.$route.path.split('/')
      if (route[1] === '' || route[1] === 'index') {
        this.selectActive('test1')
      } else if (route[1] === 'test2') {
        this.selectActive('test2')
      } else if (route[1] === 'test3') {
        this.selectActive('test3')
      }
    },
    selectActive (activeItem) {
      for (let key in this.isActive) {
        this.isActive[key] = false
      }
      this.isActive[activeItem] = true
    },
    showBarcode () {
      this.$store.commit('SET_BARCODESHOW', true)
    },
    logout () {
      logout()
      removeToken()
      if (localStorage.getItem('toPath')) {
        localStorage.removeItem('toPath')
      }
      if (this.$route.path !== '/index') {
        this.$router.push('/index')
      }
      this.$message.success('您已退出登录')
    },
    getLatestWatched () {
      if (this.$store.state.userId && this.$store.state.login) {
        getLatestWatched(this.$store.state.userId)
          .then((res) => {
            if (res.data.data.contents instanceof Array) {
              this.latestWatchedList = res.data.data.contents
              if (this.latestWatchedList.length > 3) {
                this.latestWatchedList = this.latestWatchedList.slice(0, 3)
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
}
</script>

<style scoped>
.header-container{
  position:fixed;
  z-index:999;
  background-color: #fff;
  width:100%;
}
.header {
  height: 89px;
  box-shadow: 0px 4px 9px 1px rgba(44, 44, 44, 0.04);
}
.logo {
  float: left;
  /* width: 40px; */
  height: 100%;
  display: flex;
  align-items: center;
  /* background-color: red; */
}
.logo img {
  width: 190px;
  height: 37px;
}

.menu {
  float: right;
  display: flex;
  justify-content: space-between;
  width:600px;
  height: 100%;
  line-height: 4.5;
  font-size: 16px;
  /* background-color: blue; */
}

.login {
  float: left;
  height: 100%;
  display:flex;
  align-items: center;
  cursor: pointer;
}
.wx-login:hover {
  /* color: #26bf9b; */
background: #00A47D;
}
.header-body {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.wx-login {
  /* height: 100%; */
  width: 86px;
  height: 36px;
  text-align: center;
  color:#ffffff;
  line-height:36px;
  background: #26BF9B;
  border-radius: 18px;
  position: relative;
}
/* .wx-login:hover .barcode{
    display: block;
  } */
.login div {
  float: left;
}
.user-center {
  position: relative;
  height: 100%;
}
.user-center .user-name {
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.user-name .avatar-img {
  height: 46px;
  width: 46px;
  margin-right:20px;
  border-radius: 50%;
  margin-right: 20px;
}
.isLogin {
  display: block;
}
.user-card {
  position: absolute;
  top: 81px;
  z-index: 999;
  width: 140px;
  height: 133px;
  background: #ffffff;
  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}
.barcodeShow {
  display: block;
}
/* .user-name:hover .user-card {
    display: block;
  } */
/* .user-card {
    display: none;
    position: absolute;
    z-index: 999;
    top: 76px;
    left: -50px;
    width: 200px;
    background-color: #fff;
    cursor:initial;
    border-top: 1px solid #F8F8F9;
  } */
.vip {
  width: 20px;
  position: relative;
  top: 4px;
}
</style>

<style lang="scss" scoped>
.user-card {
  .item {
    display: flex;
    align-items: center;
    color: #999999;
    img {
      margin-left: 21px;
      margin-right: 11px;
      width: 21px;
      height: 21px;
    }
    span {
      font-size: 16px;
    }
    &:hover {
      color: #26bf9b;
    }
  }
}
.search{
   display:flex;
  align-items:center;
}

/deep/ .el-input__inner {
  width: 280px;
  height: 36px;
  border-radius: 18px;
  border: 1px solid #cccccc;
}
/deep/ .el-input__inner:hover {
  border: 1px solid #26BF9B;
}
/deep/ .el-input__inner:focus {
  border: 1px solid #26BF9B;
}
/deep/ .el-input__suffix{
  margin-top:2px;
}
/deep/ .el-input__icon {
  margin-right: 10px;
  font-size:20px;
  transition: all ease .1s;
}

/deep/ .el-input__icon:hover {
  transform: scale(1.01);
  color:#26bf9b;
}
/deep/ .el-input__icon:focus{
  transform: scale(1.2);
}
/deep/ .el-dialog {
  height: 470px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue